<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
  
    <main id="renew2_mypage">
        <div class="top_container renew2_pc">
            <div class="renew2_wrapper renew2_flex">
                <div class="mypage_contents">
                    <h2>パスワード再設定</h2>
                    <div class="mypage_contents__01">
                        <div class="change_info">
                            <div class="change_info_mail">
                                <h3>メールアドレス</h3>
                                <br>
                                <ul>
                                  <el-input class="input-md" placeholder=""
                                    title="メールアドレス" ref="email" v-model="reconfirmEmail" type="email"></el-input>
                                </ul>
                                <br>
                                <div class="out_block">
                                    <a href="#" @click="mailUpdate()" class="out_btn">パスワード再設定メールを送る</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                </div>
            </div>
        </div>


        <!--SP-->
        <div class="top_container renew2_sp">
            <div class="renew2_wrapper">
                <h2>パスワード再設定</h2>
                <div class="change_info_mail">
                    <h3>メールアドレス</h3>
                    <ul>
                      <el-input class="input-md" placeholder=""
                        title="メールアドレス" ref="email" v-model="reconfirmEmail" type="email"></el-input>
                    </ul>
                    <br>
                    <div class="out_block">
                        <a href="#" @click="mailUpdate()" class="out_btn">パスワード再設定メールを送る</a>
                    </div>
                </div>
            </div>
        </div>

    </main>
    
</div>
</template>

<style lang="css" src="@/assets/css/renew2_mypage.css"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>

<style scoped>
</style>



<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  components: {
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms,
    Slick
  },
  data: function () {
    return {
		  fullscreenLoading: false,
      firstStepComplete: false,
      reconfirmEmail: '',
      recentEdit: {
        FormatId: ''
      },
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      dialogVisible:false,
      name:false,
      selectedYagiOfferData:{},
      selectedQuickEmailData:{},
      mypagedata: [],
      quickemailList: [],
      qmail_rirekisho_html: '',
      qmail_shokumukeirekisho_html: '',
      backupListLoaded: {
        auto: false,
        user: false
      },
      slickOptions:{
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2400,
        speed: 400
      },
      saved: false,
      recomm_code:'',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      previewQEmailScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      qmailViewerCssRirekisho: {},
      qmailViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      rirekisho_height: 110,
      keirekisho_height: 110,
      previewQEmailLoading: false,
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho',
      activeQEmailPreviewTab: 'format_rirekisho'
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    getFormatName:function(format_id) {
      for(let p of this.$site.formatsIndex){
        if (p.id == format_id) {
          return p.title
        }
      }
      for(let p of this.$site.keirekishoFormatsIndex){
        if (p.id == format_id) {
          return p.title
        }
      }
      return '-'
    },
    mailUpdate: async function() {
      const app = this
      app.fullscreenLoading = true
      firebase.auth().sendPasswordResetEmail(app.reconfirmEmail)
      .then(() => {
        app.$message({
          duration: 0,
          showClose: true,
          message: 'パスワード再設定メールを送りました。',
          type: 'success'
        })
        app.fullscreenLoading = false
      })
      .catch((error) => {
        var errorCode = error.code
        var errorMessage = error.message
        switch (errorCode) {
          case 'auth/cancelled-popup-request':
          case 'auth/popup-closed-by-user':
            errorMessage =  null;
            break
          case 'auth/email-already-in-use':
            errorMessage =  'このメールアドレスは使用されています'
            break
          case 'auth/invalid-email':
            errorMessage =  'メールアドレスの形式が正しくありません'
            break
          case 'auth/user-disabled':
            errorMessage =  'サービスの利用が停止されています'
            break
          case 'auth/user-not-found':
            errorMessage =  'メールアドレスが見つかりません。'
            break
          case 'auth/user-mismatch':
            errorMessage =  'メールアドレスまたはパスワードが違います'
            break
          case 'auth/weak-password':
            errorMessage =  'パスワードは6文字以上にしてください'
            break
          case 'auth/wrong-password':
            errorMessage =  'メールアドレスまたはパスワードが違います'
            break
          case 'auth/popup-blocked':
            errorMessage =  '認証ポップアップがブロックされました。ポップアップブロックをご利用の場合は設定を解除してください'
            break
          case 'auth/operation-not-supported-in-this-environment':
          case 'auth/auth-domain-config-required':
          case 'auth/operation-not-allowed':
          case 'auth/unauthorized-domain':
            errorMessage =  '現在この認証方法はご利用頂けません'
            break
          case 'auth/requires-recent-login':
            errorMessage =  '認証の有効期限が切れています'
            break
          default:
            errorMessage =  'エラーが発生しました。しばらく時間をおいてお試しください'
            break
        }
        app.$message({
          message: '失敗しました。' + errorMessage,
          type: 'error'
        })
        app.fullscreenLoading = false
      });
    }
  },
  created: function () {
    const app = this
  },
  beforeMount: function () {
  },
  destroyed: function () {
  }
}
</script>
